import { z } from 'zod';

import { YARD_STAGES } from './yard-stages.js';

export const CreateYardStandaloneCardBodySchema = z.object({
  title: z.string().min(1).max(255),
  stage: z.enum(YARD_STAGES),
});
export type CreateYardStandaloneCardBody = z.infer<typeof CreateYardStandaloneCardBodySchema>;

export const YardStandaloneCardSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  title: z.string(),
  stage: z.enum(YARD_STAGES),
  createdAt: z.iso.datetime(),
});
export type YardStandaloneCard = z.infer<typeof YardStandaloneCardSchema>;

export const CreateYardStandaloneCardResponseSchema = YardStandaloneCardSchema;
export type CreateYardStandaloneCardResponse = YardStandaloneCard;

export const DeleteYardStandaloneCardResponseSchema = z.object({ id: z.uuid() });
export type DeleteYardStandaloneCardResponse = z.infer<
  typeof DeleteYardStandaloneCardResponseSchema
>;
